<template>
	<router-link class="text-decoration-none" :to="navigateTo">
		<Row class="card-container width-100 flex-align-center flex-justify-space-between">
			<IssueCardIconAndTexts :issue="issue" class="flex-col-9 pr-4 ml-1" />
			<Row class="flex-align-center flex-col-3">
				<h3 class="light mr-8 last-error-box">{{ lastErrorTimeAgo }}</h3>
				<h3 class="light error-rate">
					{{ ((issue.count / issue.totalRuns) * 100).toFixed(1) }}% ({{ issue.count }}/{{ issue.totalRuns }})
				</h3>
			</Row>
		</Row>
	</router-link>
</template>
<script>
import moment from 'moment';
import { ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME } from '@/router/router.const';
import IssueCardIconAndTexts from '@/views/IssuesView/IssueCardIconAndTexts.vue';
import CreateAndManageService from '@/views/AppLayout/ManageAndCreate/create-and-manage-service';
export default {
	name: 'IssueCard',
	components: { IssueCardIconAndTexts },
	props: {
		issue: { type: Object, required: true },
	},
	computed: {
		flowData() {
			return this.issue.flow_data;
		},
		lastErrorTimeAgo() {
			return moment(this.issue.last_occurrence).fromNow();
		},
		navigateTo() {
			const workflowId = this.flowData.id;
			const issueId = this.issue.error_message; // for now, use the issue error_message as the issue id, until BE will arrange it differently
			return { name: this.routeNamePrefix + ISSUES_MANAGEMENT_TASK_LOG_ROUTE_NAME, params: { workflowId, issueId } };
		},
		routeNamePrefix() {
			return CreateAndManageService.getPlacementRoutePrefix(this.$route);
		},
	},
	methods: {},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.last-error-box {
	width: 116px;
}
.router-link {
	text-decoration: none !important;
}
.card-container {
	height: 70px;
	border-radius: 13px;
	background-color: var(--bg-color);

	&:hover {
		cursor: pointer;
		transition: 0.1s;
		background: #f5f7fa;

		.menu-button {
			border: 1px solid var(--forth-border-color);
		}
	}

	&:not(:hover) {
		transition: 0.1s;
		::v-deep {
			.buttons-dropdown-icon {
				transition: 0.1s;
				color: #90909070 !important;
			}
		}
	}
}

.workflow-form-icon-container {
	width: 34px;
}

.buttons-dropdown-title {
	font-size: 15px;
	font-weight: normal;
	color: var(--primary-font-color);

	overflow: hidden;
	display: -webkit-box;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2; // num of rows to break
}

.menu-button {
	background: transparent !important;
}
.icon-container {
	transform: scale(0.8);
}
.workflow-title {
	font-size: 15px;
	font-weight: normal;
	color: var(--primary-font-color);

	overflow: hidden;
	display: -webkit-box;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2; // num of rows to break
}
</style>
